export const downloadFile = (
	file: File,
	newFileName: string = `${new Date().getTime()}.pdf`,
) => {
	const url = URL.createObjectURL(file);
	const link = document.createElement('a');
	link.href = url;
	link.download = newFileName;
	link.click();
};

export const downloadFromUrl = async (
	url: string,
	fileName: string = 'document.pdf',
) => {
	const response = await fetch(url);
	const blob = await response.blob();
	const objectUrl = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = objectUrl;
	link.download = fileName;
	link.click();
	URL.revokeObjectURL(objectUrl);
};
